import { FaRegFolder } from "react-icons/fa";
import { openFolder } from "../misc";
import { OrangeButtonWithIcon } from "../Buttons";

type ButtonProps = {
    children: React.ReactNode
    className?: string
    onClick?: () => void
    disabled?: boolean
}

export function Button({children, className, ...props}: ButtonProps) {
    return (
        <button className={`button ${className}`} {...props}>
            {children}
        </button>
    )
}

export function OpenFolderButton({folder_path}: {folder_path: string}) {
    return (
        <OrangeButtonWithIcon onClick={() => openFolder(folder_path)} icon={<FaRegFolder />}>Open Folder</OrangeButtonWithIcon>
    )
}